import React from "react";
import "./CsrGuidelines.css";

const guidelines = [
  {
    step: "01",
    title: "Eligibility & Registration",
    desc:
      "Only eligible corporates, registered NGOs, and authorized government bodies can participate in CSR activities through the portal. All entities must complete profile verification before submitting or approving projects.",
    icon: "fa-solid fa-user-check",
  },
  {
    step: "02",
    title: "Project Submission",
    desc:
      "NGOs must submit detailed project proposals including objectives, estimated costs, timelines, and expected impact. All submissions must align with Schedule VII of the Companies Act, 2013.",
    icon: "fa-solid fa-file-lines",
  },
  {
    step: "03",
    title: "Approval & Funding",
    desc:
      "Corporate entities review submitted projects and approve funding based on CSR priorities, compliance requirements, and impact potential. Approved projects move to implementation phase.",
    icon: "fa-solid fa-circle-check",
  },
  {
    step: "04",
    title: "Monitoring & Reporting",
    desc:
      "All ongoing projects must submit periodic progress reports, utilization certificates, and impact assessments through the portal to ensure transparency and accountability.",
    icon: "fa-solid fa-chart-line",
  },
  {
    step: "05",
    title: "Audit & Compliance",
    desc:
      "Projects are subject to audit and verification by authorized agencies. Non-compliance or misuse of funds may result in suspension or blacklisting.",
    icon: "fa-solid fa-shield-halved",
  },
];

const CsrGuidelines = () => {
  return (
    <section className="csr-guidelines-section">
      <div className="container">
        {/* Header */}
        <div className="csr-guidelines-header">
          <span className="csr-guidelines-badge">IMPORTANT</span>
          <h2 className="csr-guidelines-title">CSR Portal Guidelines</h2>
          <p className="csr-guidelines-subtitle">
            Please read and follow the guidelines carefully before participating
            in CSR activities through the portal.
          </p>
        </div>

        {/* Guidelines Grid */}
        <div className="csr-guidelines-grid">
          {guidelines.map((item, index) => (
            <div className="csr-guideline-card" key={index}>
              <div className="csr-guideline-top">
                <span className="csr-guideline-step">{item.step}</span>
                <div className="csr-guideline-icon">
                  <i className={item.icon}></i>
                </div>
              </div>

              <h4 className="csr-guideline-title">{item.title}</h4>
              <p className="csr-guideline-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CsrGuidelines;